<template>
  <div>
    <Empty v-if="productList.length === 0" description="暂无产品信息">
    </Empty>
    <div v-else>
      <p class="title">
        <span>{{ productList[0] && productList[0].planName }}</span>
      </p>
      <div class="display">
        <img :src="productList[0] && productList[0].otherImage" alt="">
      </div>
      <div class="tips">
        请从以下套餐任选一款进行兑换
      </div>
      <div class="list">
        <Grid :column-num="2" :gutter="10" :center="false">
          <GridItem v-for="(item, index) of productList" :key="index">
            <div class="item">
              <div @click="toDetail(item.id)">
                <img class="itemImage" :src="item.proPicDTOS && item.proPicDTOS[0] && item.proPicDTOS[0].url" alt="">
                <p class="itemText">{{ item.name }}</p>
              </div>
            </div>
          </GridItem>
        </Grid>
      </div>
    </div>

  </div>
</template>

<script>
import {Grid, GridItem, Button, Empty, Toast, Dialog} from 'vant'
import axios from "axios";
import store from "../store";
import config from "../config";
export default {
  components: {
    Grid,
    GridItem,
    Button,
    Empty
  },
  props: {
    planId: String
  },
  data () {
    return {
      id: '',
      sharedStore: store.state,
      productList: []
    }
  },
  methods: {
    getData (id) {
      const { token } = this.sharedStore
      Toast.loading({
        message: '加载中',
        forbidClick: true
      })
      axios.get(
          `${config.publicPath}/exchange-api/api/product/page?planId=${id}&page=1&limit=-1`,
          {
            headers:{
              "token": token
            }
          }
      ).then(res => {
        const { code, msg, data } = res.data
        if (code === 0) {
          Toast.clear()
          this.productList = data.list
        } else {
          Toast.clear()
          Toast.fail(msg)
        }
      })
    },
    toDetail (id) {
        this.$router.push({
        path: `/detail/${id}`,
        query: {
          cant: this.$route.query.cant
        }
      })
    },
  },
  mounted() {
    if (this.$props.planId) {
      this.id = this.$props.planId
    } else {
      const { id } = this.$route.params
      this.id = id
    }
    this.getData(this.id)
  }
}
</script>

<style scoped lang="less">
.title {
  text-align: center;
  color: black;
  font-size: 16px;
  font-weight: bold;

  & > span {
    border-bottom: solid 3px #1989fa;
    padding: 4px;
  }
}

.display {
  margin-bottom: 20px;

  img {
    width: 100%;
    object-fit: contain;
  }
}

.tips {
  padding: 0 10px;
  margin: 10px 0;
  font-size: 16px;
  font-weight: bold;
}

.list {
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .itemImage {
    width: 140px;
    height: 140px;
    object-fit: cover;
  }
  .itemText {
    font-size: 12px;
    width: 100%;
    margin: 10px 0 0 0;
    height: 36px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height: 72px;
  }
}
</style>